import { Route, Switch } from "react-router-dom";
import Home from "./component/pages/Home";
import Header from "./component/Header/header";
import Product from "./component/Product/Product";
import Cart from "./component/Cart/Cart";
import Wishlist from "./component/Wishlist/wishlist";
import Productpage from "./component/pages/productpage";
import LoginPage from "./component/LoginPage/loginpage";
import SignUp from "./component/SignUp/SignUp";
import ForgotPasswordScreen from "./component/ForgotPassword/ForgotPasswordScreen";
import ResetPasswordScreen from "./component/ResetPasswordScreen/ResetPasswordScreen";
import PrivateRoute from "./component/Routing/PrivateRoute";
import Footer from "./component/Footer/Footer";
import Contact from "./component/Contact/Contact";
import Trackorder from "./component/TrackOrder/TrackOrder";
import Breadcrumb from "./component/Header/breadcrumb";
import PrivateScreen from "./component/pages/Prviatescreen";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div>
      <Toaster position="bottom-right" />
      <Breadcrumb />
      <Header />
      <Switch>
        <PrivateRoute path="/private" component={PrivateScreen} />
        <Route exact path="/" component={Home} />
        <Route exact path="/shop" component={Product} />
        <PrivateRoute exact path="/cart" component={Cart} />
        <PrivateRoute exact path="/wishlist" component={Wishlist} />
        <Route exact path="/productdetails/:id" component={Productpage} />
        <Route exact path="/auth/login" component={LoginPage} />
        <Route exact path="/auth/signup" component={SignUp} />
        <Route
          exact
          path="/auth/forgotpassword"
          component={ForgotPasswordScreen}
        />
        <Route
          exact
          path="/passwordreset/:resetToken"
          component={ResetPasswordScreen}
        />
        <Route exact path="/contactus" component={Contact} />
        <Route exact path="/trackorder" component={Trackorder} />
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
